import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Display from './components/Display/Display';
import Landing from './components/Landing/Landing';
import GameStopsIntermediary from './components/GameStopsIntermediary/GameStopsIntermediary';
import ScoreSharing from './components/ScoreSharing/ScoreSharing';
import GameStopSideBar from './components/GameStopSideBar/GameStopSideBar';
import FeedBackButton from './components/FeedBackButton/FeedBackButton';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            valid: true,
            loading: true,
            gameData: {},
            activePage: 0,
            gameState: {},
        };
    }

    componentDidMount() {
      this.setState({ valid: true, loading: false, gameData: require('./assets/data/data.json') })
    }
    
    goto = (page, state) => {
        let newGameState = this.state.gameState;
        newGameState[page] = state;
        this.setState({
            activePage: page,
            gameState: newGameState
        });
        window.scrollTo(0, 0);
    }
    
    renderPage = () => {
        switch(this.state.activePage) {
            case 0: return <Landing navigate={this.goto} gameData={this.state.gameData}/>;
            case 1: return <Display navigate={this.goto} gameData={this.state.gameData} gameState={this.state.gameState[1]}/>;
            case 2: return <GameStopsIntermediary navigate={this.goto} gameState={this.state.gameState[2]}/>;
            case 3: return <ScoreSharing navigate={this.goto} gameState={this.state.gameState[3]}/>;
            case 4: return <GameStopSideBar navigate={this.goto} gameState={this.state.gameState[4]}/>;
            default: return null;
        }
    };

    render() {
        if(this.state.loading) {
            return null;
        }
        return (
            <div className="roper-container">
                {/* <div>DEVELOPMENT</div> */}
                <BrowserRouter basename="/weathervane">
                    <Switch>
                        <Route path='/' render={() => this.renderPage()}/>
                    </Switch>
                </BrowserRouter>
                <FeedBackButton />
            </div>
        );
    }
}

export default App;